import { Footer, Header } from '../../components';
import { Layout, LayoutProps } from 'antd';

import { Content } from 'antd/lib/layout/layout';
import { CurrentUserProp } from '../../types/props/current-user.props';
import React from 'react';

const LayoutPage: React.FC<LayoutProps & CurrentUserProp> = ({
  children,
  isAdmin,
  oid
}) => (
  <Layout>
    <Header isAdmin={isAdmin} oid={oid} />
    <Content className='site-layout main-content'>
      <div
        className='site-content-background'
        style={{ padding: 24, minHeight: 380 }}>
        {children}
      </div>
    </Content>
    <Footer />
  </Layout>
);

export default LayoutPage;
